import { type SVGProps } from 'react';

export const Caret = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="6"
    viewBox="0 0 10 6"
    width="10"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10 0.5L5 5.5L0 0.5L10 0.5Z" />
  </svg>
);
